<template>
    <header id="header" class="tra-menu white-scroll">
        <div class="header-wrapper">
            <HeaderLogo />
            <HeaderMenu />
        </div>
    </header>
</template>
